import { DashboardAccountResponse } from '@interfaces/models';
import { useTranslation } from 'react-i18next';
import { Typography } from '@ui/components';
import { DateTime } from 'luxon';

interface DashboardWalletProgressBarProps {
  account: DashboardAccountResponse;
}

export const DashboardWalletProgressBar = (props: DashboardWalletProgressBarProps) => {
  const { account } = props;
  const { t } = useTranslation();

  const now = DateTime.now();
  const daysInMonth = now.daysInMonth;

  const daysLeft = Math.min(account.daysLeft ?? 0, daysInMonth);
  const daysLeftPercentage = (daysLeft / daysInMonth) * 100;

  return (
    <div className="flex flex-col gap-4">
      <Typography variant="labelMediumMedium" className="text-weak">
        {t('DASHBOARD.WALLET.PROGRESS_BAR.DAYS_LEFT', {
          count: daysLeft,
          postProcess: 'interval',
        })}
      </Typography>
      <div className="h-4 w-full rounded-full dashboard-progress-bar-gradient relative">
        <div
          className="size-6 bg-default border border-border-default rounded-full absolute top-1/2 translate-x-1/2 -translate-y-1/2"
          style={{
            right: `${daysLeftPercentage}%`,
          }}
        />
      </div>
    </div>
  );
};
